import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import {listPendingRequests, updateClientRequest,
        listRequestStatus, listRequestTypes, getClientRequestDetail} from '../../actions/clientRequestsActions';
import { mustBeArray, requestHasError, displayDateFormater, exportArrayAsCsv } from '../../utils/lib';
import { getClientRequestStatusLabel } from '../../utils/clientRequest';
import {
    CLIENT_REQUEST_APPROVED_ID,
    CLIENT_REQUEST_PENDING_CLIENT_ACTIONS_ID,
    CLIENT_REQUEST_REJECTED_ID,
    CLIENT_REQUEST_IN_COMPLETE_CLIENT_ACTIONS_ID,
    AUTO_TANK_SWAP_REQUEST_ID,
    DEFAULT_DATE_FORMAT,
    IsInRole,
    ROLE_ClientUser,
    ROLE_LocationUser,
    ROLE_SuperUser,
    URGENT_COLLECTION_REQUEST_ID,
    allowUserWithRoles,
    ROLE_OfficeUser,
    ROLE_SalesManager
} from '../../constants';
import UrgentRequestModal from '../home/UrgentRequestModal';
import ClientRequestFilters from './ClientRequestFilters';
import ClientRequestList from './ClientRequestList';
import AddToRunModal from './AddToRunModal';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';

const getDefaultFilters = (statusList) => ({
    requestStatusIds: mustBeArray(statusList).filter(s => s.id !== CLIENT_REQUEST_IN_COMPLETE_CLIENT_ACTIONS_ID).map(s => s.id),
    dateFrom: moment().subtract(3, 'months').format(DEFAULT_DATE_FORMAT),
    dateTo: moment().format(DEFAULT_DATE_FORMAT),
});

const ClientRequestView = props => {
    const {dispatch, pendingRequestsList, account} = props;
    const [viewRequestModal, setViewRequestModal] = useState(false);
    const [activePendingRequest, setActivePendingRequest] = useState({});
    const [approveLoading, setApproveLoading] = useState(false);
    const [declineLoading, setDeclineLoading] = useState(false);
    const [pendingLoading, setPendingLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [filters, setFilters] = useState({});
    const [selectedClientLocations, setSelectedClientLocations] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [requestTypes, setRequestTypes] = useState([]);
    const [activeRunPickerLocation, setActiveRunPickerLocation] = useState(null);
    useEffect(() => {
        if(allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser, ROLE_SalesManager])){
          Promise.all([dispatch(listRequestStatus()), dispatch(listRequestTypes())]).then(([statusResp, typeResp]) => {
            const statuses = mustBeArray(statusResp && statusResp.data);
            const types = mustBeArray(typeResp && typeResp.data);
            setStatusList(statuses);
            setRequestTypes(types);
            const defaultFilters = getDefaultFilters(statuses);
            setFilters(defaultFilters);
            dispatch(listPendingRequests({getTotal:false, filters: defaultFilters}));
          });
        }
        else {
          getPendingRequest({reset:true});
        }
        // Update the total number of pending requests on page load
        dispatch(listPendingRequests({getTotal:true}));
    }, []);

    useEffect(() => {
        if(!_.isEmpty(activePendingRequest)){
          setViewRequestModal(true);
        }
      }, [activePendingRequest]);

    const getPendingRequest = ({reset=false}) => {
        dispatch(listPendingRequests({getTotal:false, filters: reset? {}: filters}));
    };

    const handleRequestModalClose = () => {
      setActivePendingRequest({});
      setViewRequestModal(false);
      stopAllLoading();
    };

    const handleNoteChange = e => {
      setActivePendingRequest({...activePendingRequest, feedback: e.currentTarget.value});
    };

    const handleFilterChange = ({value, field, isMulti=false}) => {
      if(['dateFrom','dateTo'].includes(field)){
          value = value.format(DEFAULT_DATE_FORMAT);
      }
      if(isMulti){
          value = value ? String(value).split(",") : [];
      }
      let updatedFilters = {...filters, [field]: value};
      setFilters(updatedFilters);
  };

  const handleClientLocationChange = (selectedOptions) => {
    const options = mustBeArray(selectedOptions);
    setSelectedClientLocations(options);
    setFilters({
      ...filters,
      clientIds: options.filter(o => o.entityType === "Client").map(o => o.clientId),
      locationIds: options.filter(o => o.entityType === "Location").map(o => o.locationId),
    });
  };

  const handleAddToRun = ({locationId, requestTypeId}) => {
    setActiveRunPickerLocation({locationId, requestTypeId});
  };

  const handleExportCsv = () => {
    exportArrayAsCsv({
      rows: pendingRequestsList,
      columns: [
        {header: 'Client Name', accessor: r => r.clientName},
        {header: 'Client Location', accessor: r => r.locationName},
        {header: 'Request Type', accessor: r => r.requestTypeName},
        {header: 'Request Date', accessor: r => displayDateFormater({value: r.dateCreated})},
        {header: 'Requested By', accessor: r => r.requestTypeId === AUTO_TANK_SWAP_REQUEST_ID ? 'System' : r.createdBy},
        {header: 'Status', accessor: r => getClientRequestStatusLabel({statusId: r.requestStatusId, fallbackName: r.requestStatusName})},
        {header: 'Scheduled', accessor: r => r.runDate ? displayDateFormater({value: r.runDate}) : ''},
      ],
      filename: `client-requests_${moment().format('YYYYMMDD_HHmmss')}.csv`,
    });
  };

  const handleRunPickerClose = () => {
    setActiveRunPickerLocation(null);
  };

  const handleRunAdded = () => {
    handleRunPickerClose();
    toastr.success('Location added to run.');
    getPendingRequest({reset: false});
  };

  const handleRequest = ({action}) => {
    let payLoad = {
      feedback: activePendingRequest && activePendingRequest.feedback,
      attachments: activePendingRequest && activePendingRequest.files,
      locationId: activePendingRequest && activePendingRequest.locationId,
      id: activePendingRequest && activePendingRequest.id,
    };
    let successMessage = "";
    switch(action){
      case "approve":
        setApproveLoading(true);
        payLoad.requestStatusId = CLIENT_REQUEST_APPROVED_ID;
        successMessage = 'Client request approved.';
        break;
      case "deny":
        setDeclineLoading(true);
        payLoad.requestStatusId = CLIENT_REQUEST_REJECTED_ID;
        successMessage = 'Client request rejected.';
        break;
      case "pending":
        setPendingLoading(true);
        payLoad.requestStatusId = CLIENT_REQUEST_PENDING_CLIENT_ACTIONS_ID;
        successMessage = 'Client request set as pending action.';
        break;
      case "save":
        setSaveLoading(true);
        payLoad.requestStatusId = activePendingRequest && activePendingRequest.requestStatusId;
        successMessage = 'Client request saved.';
        break;
      default:
        break;
    }
    if(activePendingRequest && activePendingRequest.requestTypeId !== URGENT_COLLECTION_REQUEST_ID){
      payLoad.tankId = activePendingRequest && activePendingRequest.tankId;
    }
    dispatch(updateClientRequest({payLoad, action})).then(resp => {
      if(!requestHasError({x:resp})){
        getPendingRequest({reset: false});
        dispatch(listPendingRequests({getTotal:true}));
        handleRequestModalClose();
        toastr.success(successMessage);
      }
      else{
        stopAllLoading();
      }
    });
  };

  const stopAllLoading = () => {
    setApproveLoading(false);
    setDeclineLoading(false);
    setPendingLoading(false);
    setSaveLoading(false);
  };
  
  const handleResetFilter = () => {
    const defaultFilters = getDefaultFilters(statusList);
    setFilters(defaultFilters);
    setSelectedClientLocations([]);
    dispatch(listPendingRequests({getTotal:false, filters: defaultFilters}));
  };
  const handleSearch = () => {
    getPendingRequest({reset:false});
  };

  const handleViewRequest = ({id}) => {
      dispatch(getClientRequestDetail({id})).then(resp => {
        if(!requestHasError({x: resp})){
          setActivePendingRequest({...resp && resp.data, files: resp.data && resp.data.attachments});
        }
      });
  };

  const handleFileUploads = ({fileList}) => {
      setActivePendingRequest({...activePendingRequest, files: [...activePendingRequest && activePendingRequest.files, ...fileList]});
  };

  const handleFileDelete = ({image, index}) => {
      let tempFileCollection = [...activePendingRequest && activePendingRequest.files];
      tempFileCollection.splice(index, 1);
      setActivePendingRequest({...activePendingRequest, files: [...tempFileCollection]});
  };
  
  const isOfficeOrSuperUser = allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser, ROLE_SalesManager]);
  const canManageRuns = allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser]);
  
    return(
        <div className="mb-1">
            <div className={"row"}>
                <div className={"col-12"} style={{marginBottom: "24px"}}>
                    <h4>{`${isOfficeOrSuperUser ? "Client" : "Open"} Requests`}</h4>
                </div>
            </div>
            { isOfficeOrSuperUser && 
              <Row className="mb-2">
                <Col sm={12} md={7} lg={6}>
                    <ClientRequestFilters
                        filters={filters}
                        handleFilterChange={handleFilterChange}
                        handleSearch={handleSearch}
                        handleResetFilter={handleResetFilter}
                        statusList={statusList}
                        requestTypes={requestTypes}
                        selectedClientLocations={selectedClientLocations}
                        handleClientLocationChange={handleClientLocationChange}
                        handleExportCsv={handleExportCsv}
                    />
                </Col>
            </Row>
            }
            
            <ClientRequestList
                list={pendingRequestsList}
                handleViewRequest={handleViewRequest}
                showRunLink={isOfficeOrSuperUser}
                canManageRuns={canManageRuns}
                handleAddToRun={handleAddToRun}
            />
            <AddToRunModal
              isOpen={!!activeRunPickerLocation}
              locationId={activeRunPickerLocation && activeRunPickerLocation.locationId}
              requestTypeId={activeRunPickerLocation && activeRunPickerLocation.requestTypeId}
              onClose={handleRunPickerClose}
              onAdded={handleRunAdded}
            />
            <UrgentRequestModal
              title={activePendingRequest.requestTypeName || ""}
              images={mustBeArray(activePendingRequest && activePendingRequest.files)}
              viewRequestModal={viewRequestModal}
              submitButtonText={(activePendingRequest && activePendingRequest.requestTypeId === URGENT_COLLECTION_REQUEST_ID) ?  "Request an Urgent Collection" : "Request Tank Swap"}
              handleNoteChange={handleNoteChange}
              notes={activePendingRequest && activePendingRequest.feedback || ""}
              handleModalClose={handleRequestModalClose}
              handleRequest={handleRequest}
              reviewMode={true}
              approveLoading={approveLoading}
              declineLoading={declineLoading}
              pendingLoading={pendingLoading}
              saveLoading={saveLoading}
              instruction={activePendingRequest && activePendingRequest.additionalInformation}
              requestStatus={activePendingRequest && activePendingRequest.requestStatusId}
              isSuperAdmin={allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser, ROLE_SalesManager])}
              isClientUser={IsInRole(account, ROLE_ClientUser)||IsInRole(account, ROLE_LocationUser)}
              handleFileUploads={handleFileUploads}
              handleFileDelete={handleFileDelete}
              activePendingRequest={activePendingRequest}
            />
        </div>
    );
};

function mapStateToProps(state, ownProps){

    return {
      pendingRequestsList: mustBeArray(state.clientRequests && state.clientRequests.list),
      account: state.account,
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      dispatch,
      listPendingRequests,
      updateClientRequest,
      listRequestStatus,
      listRequestTypes,
      getClientRequestDetail
    };
  }

export default connect(mapStateToProps, mapDispatchToProps) (ClientRequestView);